// extracted by mini-css-extract-plugin
export default {"container":"BEQTX00KhSGgEIANEZZj","content":"b61LP0Iqs29BWfDhwUVB","pillsRow":"oCxb3iZNRPRL2SAPbcPc","titleRow":"BQZzNr25p2BolHi7voaY","title":"MVEQGBk5uCQ3UtXEGmZr"};